import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ResourceViewerModalService {

  private viewSubject = new BehaviorSubject(false);
  view$: Observable<boolean> = this.viewSubject.asObservable();

  private urlSubject = new BehaviorSubject(undefined);
  url$: Observable<string> = this.urlSubject.asObservable();

  constructor() { }

  next(view: boolean, url: string) {
    this.viewSubject.next(view);
    this.urlSubject.next(url);
  }


}
